import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import config from "../../common/Config";
import axios from 'axios';
import { toast } from 'sonner';
import { Box, Typography, TextField, Button, Grid2, FormControl, InputLabel, Select, MenuItem, Radio, RadioGroup, FormControlLabel, FormLabel, Checkbox, Paper, Autocomplete } from '@mui/material';
import { Iconify } from '../../Minimal/src/components/iconify/iconify';
import '../../common/commonStyles.css';
import { encryptPayload, decryptPayload } from '../../../utils/customerCrypto';
import { getCompanySettings, resolveCustomerApiEncrypt } from '../../../utils/companySettingsCache';
const Edit_Customer = ({
  customerId: customerIdProp,
  embedded = false,
  onClose,
  headerActions = null,
}) => {

  const params = useParams();
  const customerId = customerIdProp || params.customerId;
  const token = localStorage.getItem("token");
  const accessToken = localStorage.getItem('accessToken');
  const company_tax_type = localStorage.getItem('company_tax_type');
  const userId = localStorage.getItem('userId');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [businessType, setBusinessType] = useState([]);
  const [businessRute, setBusinessRute] = useState([]);
  const [businessCategory, setBusinessCategory] = useState([]);
  const [errors, setErrors] = useState({});
  const [facilityError, setFacilityError] = useState('');
  const [sameAsBillTo, setSameAsBillTo] = useState(false);

  const buildImageCandidates = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return [];
    if (/^(https?:)?\/\//i.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) {
      return [raw];
    }
    const apiRoot = String(config.API_URL || '').replace(/\/api\/?$/i, '');
    const roots = [apiRoot, config.BASE_URL].filter(Boolean).map((r) => String(r).replace(/\/+$/, ''));
    const normalizedPath = raw.replace(/^\/+/, '');
    const directPath = `/${normalizedPath}`;
    const uploadPath = `/uploads/${normalizedPath}`;
    const customerUploadPath = `/uploads/customer/${normalizedPath}`;
    const arr = [raw, directPath, uploadPath, customerUploadPath];
    roots.forEach((root) => {
      arr.push(`${root}${directPath}`);
      arr.push(`${root}${uploadPath}`);
      arr.push(`${root}${customerUploadPath}`);
    });
    return [...new Set(arr)];
  };
  const [drivingImageIndex, setDrivingImageIndex] = useState(0);
  const [passportImageIndex, setPassportImageIndex] = useState(0);
  const [drivingImageUnavailable, setDrivingImageUnavailable] = useState(false);
  const [passportImageUnavailable, setPassportImageUnavailable] = useState(false);

  const [formData, setFormData] = useState({
    companyName: '',
    firstName: '',
    emailId: '',
    phone: '',
    accound_no: '',
    route: '',
    addressLine1: '',
    city: '',
    postalCode: '',
    county: '',
    vatNo: '',
    driving_license: '',
    passport: '',
    default_delivery: '',
    typeOfBusiness: '',
    businessCategory: '',
    product_price: '',
    credit_facility: '',
    day_wise: '',
    total_day: '',
    invoice_wise: '',
    total_invoice: '',
    amount_wise: '',
    total_amount: '',
    shiptoName: '',
    shipLine1: '',
    shipLine2: '',
    shipCity: '',
    shipPostcode: '',
    shipState: '',
  });

  // Add state for Qty Discount
  const [qtyDiscount, setQtyDiscount] = useState('0'); // 0 = No, 1 = Yes
  const [creditFacility, setCreditFacility] = useState('0');

  // Keep Ship To in sync when 'Same as Bill To' is enabled
  useEffect(() => {
    if (sameAsBillTo) {
      setFormData((prev) => ({
        ...prev,
        shiptoName: prev.firstName || prev.companyName || '',
        shipLine1: prev.addressLine1 || '',
        shipLine2: prev.addressLine2 || '',
        shipCity: prev.city || '',
        shipPostcode: prev.postalCode || '',
        shipState: prev.county || '',
      }));
    }
  }, [sameAsBillTo, formData.firstName, formData.companyName, formData.addressLine1, formData.addressLine2, formData.city, formData.postalCode, formData.county]);

  const handleSameAsBillToChange = (e) => {
    const checked = e.target.checked;
    setSameAsBillTo(checked);
    if (checked) {
      setFormData((prev) => ({
        ...prev,
        shiptoName: prev.firstName || prev.companyName || '',
        shipLine1: prev.addressLine1 || '',
        shipLine2: prev.addressLine2 || '',
        shipCity: prev.city || '',
        shipPostcode: prev.postalCode || '',
        shipState: prev.county || '',
      }));
    }
  };

  const fetchBusinessTypeList = async () => {
    const apiBTUrl = `${config.API_URL}/ws-get-business-types_web`;
    try {
      const response = await fetch(apiBTUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch brand list");
      }

      const data = await response.json();
      const resolved =
        decryptPayload(data?.encrypted_payload) ||
        decryptPayload(data?.encrypted_data) ||
        decryptPayload(data?.payload) ||
        data;
      setBusinessType(Array.isArray(resolved?.businessTypes) ? resolved.businessTypes : []);

    } catch (error) {
      console.log("Error fetch brand list", error);
    }

  };
  const fetchBusinessCategoryList = async () => {


    const apiBCUrl = `${config.API_URL}/ws-get-business-categories_web`;
    try {
      const response = await fetch(apiBCUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch brand list");
      }

      const data = await response.json();
      const resolved =
        decryptPayload(data?.encrypted_payload) ||
        decryptPayload(data?.encrypted_data) ||
        decryptPayload(data?.payload) ||
        data;
      setBusinessCategory(Array.isArray(resolved?.businessCategories) ? resolved.businessCategories : []);

    } catch (error) {
      console.log("Error fetch brand list", error);
    }

  };

  const fetchBusinessRouteList = async () => {
    const brForm = new FormData();

    brForm.append("platform", 'web');

    const apiBRUrl = `${config.API_URL}/getRoute`;
    try {
      const response = await fetch(apiBRUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: brForm,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch brand list");
      }

      const data = await response.json();
      const resolved =
        decryptPayload(data?.encrypted_payload) ||
        decryptPayload(data?.encrypted_data) ||
        decryptPayload(data?.payload) ||
        data;
      const routes = Array.isArray(resolved?.data) ? resolved.data : [];
      setBusinessRute(
        routes.slice().sort((a, b) =>
          String(a?.route_number ?? '')
            .trim()
            .localeCompare(String(b?.route_number ?? '').trim(), undefined, {
              numeric: true,
              sensitivity: 'base',
            })
        )
      );


    } catch (error) {
      console.log("Error fetch brand list", error);
    }

  };

  const fetchEditCustomerInfo = async () => {
    const brForm = new FormData();
    const settings = await getCompanySettings();
    const useEncrypt = resolveCustomerApiEncrypt(settings);

    brForm.append("id", customerId);
    if (useEncrypt) {
      const encryptedRequest = encryptPayload({ id: customerId });
      if (encryptedRequest) {
        brForm.append("encrypted_payload", encryptedRequest);
      }
    }

    const apiUrl = `${config.API_URL}/ws_get_customer_details_id`;
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: brForm,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch brand list");
      }

      const data = await response.json();
      const resolved = useEncrypt
        ? (decryptPayload(data?.encrypted_payload) ||
            decryptPayload(data?.encrypted_data) ||
            decryptPayload(data?.payload) ||
            data)
        : data;
      const customerData = resolved?.data || {};
      let creditTypes = [];
      try {
        const raw = customerData.credit_type;
        const parsed = typeof raw === 'string' ? JSON.parse(raw || '[]') : Array.isArray(raw) ? raw : [];
        creditTypes = Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        creditTypes = [];
      }

      const dayWise =
        creditTypes.find((t) => t && t.name === 'day_wise') ||
        creditTypes.find((t) => t && 'total_day' in t && (t.name === '1' || t.name === 1));
      const invoiceWise =
        creditTypes.find((t) => t && t.name === 'invoice_wise') ||
        creditTypes.find((t) => t && 'total_invoice' in t && (t.name === '1' || t.name === 1));
      const amountWise =
        creditTypes.find((t) => t && t.name === 'amount_wise') ||
        creditTypes.find((t) => t && 'total_amount' in t && (t.name === '1' || t.name === 1));

      // Extract the values, ensuring we check if they exist in the found objects
      const totalDay = dayWise ? dayWise.total_day : '';
      const totalInvoice = invoiceWise ? invoiceWise.total_invoice : '';
      const totalAmount = amountWise ? amountWise.total_amount : '';




      setCreditFacility(String(customerData.credit_facility ?? '0'));

      setFormData({
        id: customerData.id,
        companyName: customerData.company,
        firstName: customerData.name,
        emailId: customerData.email,
        phone: customerData.phone,
        accound_no: customerData.accound_no,
        route: customerData.route === null || customerData.route === undefined || customerData.route === ''
          ? ''
          : String(customerData.route),
        addressLine1: customerData.line1,
        addressLine2: customerData.line2,
        city: customerData.city,
        postalCode: customerData.postal_code,
        county: customerData.state ? customerData.state : '',
        vatNo: customerData.vat_no,
        driving_license: customerData.driving_license || '',
        passport: customerData.passport || '',
        default_delivery: customerData.default_delivery,
        typeOfBusiness: customerData.type_of_business,
        businessCategory: customerData.business_category,
        product_price: customerData.product_price_type,
        credit_facility: customerData.credit_facility,
        day_wise: dayWise ? true : false,
        total_day: totalDay ? totalDay : '',
        invoice_wise: invoiceWise ? true : false,
        total_invoice: totalInvoice ? totalInvoice : '',
        amount_wise: amountWise ? true : false,
        total_amount: totalAmount ? totalAmount : '',
        shiptoName: customerData.shiptoName,
        shipLine1: customerData.shipLine1,
        shipLine2: customerData.shipLine2,
        shipCity: customerData.shipCity,
        shipPostcode: customerData.shipPostcode,
        shipState: customerData.shipState,

      });


    } catch (error) {
      console.log("Error fetch brand list", error);
    }

  };


  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
    setFacilityError('');
  };


  const navigateToCustomerList = useNavigate();


  useEffect(() => {

    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    if (!customerId) {
      return;
    }

    fetchBusinessRouteList();
    fetchBusinessTypeList();
    fetchBusinessCategoryList();

    fetchEditCustomerInfo();


  }, [customerId]);

  useEffect(() => {
    if (!businessRute.length || formData.route === '' || formData.route === null || formData.route === undefined) {
      return;
    }
    const routeValue = String(formData.route).trim();
    const matchedById = businessRute.find((r) => String(r.id) === routeValue);
    if (matchedById) {
      if (String(formData.route) !== String(matchedById.id)) {
        setFormData((prev) => ({ ...prev, route: String(matchedById.id) }));
      }
      return;
    }
    const matchedByNumber = businessRute.find(
      (r) => String(r.route_number ?? '').trim().toLowerCase() === routeValue.toLowerCase()
    );
    if (matchedByNumber) {
      setFormData((prev) => ({ ...prev, route: String(matchedByNumber.id) }));
    }
  }, [businessRute, formData.route]);

  useEffect(() => {
    setDrivingImageIndex(0);
    setDrivingImageUnavailable(false);
  }, [formData.driving_license]);
  useEffect(() => {
    setPassportImageIndex(0);
    setPassportImageUnavailable(false);
  }, [formData.passport]);

  const handleRadioChange = (event) => {
    setCreditFacility(event.target.value);
  };


  const validateForm = () => {
    const newErrors = {};
    let localFacilityError = '';

    // Company validation
    if (!formData.companyName) {
      newErrors.companyName = "Mention business Name.";
    } else if (formData.companyName.length < 2) {
      newErrors.companyName = "business name must consist of at least 2 characters.";
    } else if (formData.companyName.length > 255) {
      newErrors.companyName = "business name must not exceed 255 characters.";
    }

    // Name validation
    if (!formData.firstName) {
      newErrors.firstName = "Mention Name.";
    } else if (formData.firstName.length < 2) {
      newErrors.firstName = "Name must consist of at least 2 characters.";
    } else if (formData.firstName.length > 255) {
      newErrors.firstName = "Name must not exceed 255 characters.";
    }

    // Phone validation
    if (!formData.phone) {
      newErrors.phone = "Phone is Required.";
    } else if (!/^\d{10,12}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be between 10 and 12 digits.";
    }

    // Email validation (not mandatory when GST)
    if (company_tax_type !== 'GST') {
      if (!formData.emailId) {
        newErrors.emailId = "Email is Required.";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
        newErrors.emailId = "Please enter a valid email address.";
      }
    } else if (formData.emailId && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
      newErrors.emailId = "Please enter a valid email address.";
    }


    // Account Number 
    if (!formData.accound_no) {
      newErrors.accound_no = "Mention Name.";
    } else if (formData.accound_no.length < 2) {
      newErrors.accound_no = "Name must consist of at least 2 characters.";
    } else if (formData.accound_no.length > 15) {
      newErrors.accound_no = "Name must not exceed 15 digits.";
    }




    if (!formData.route) {
      newErrors.route = "Mention Route.";
    }
    if (!formData.typeOfBusiness) {
      newErrors.typeOfBusiness = "Mention typeOfBusiness.";
    }
    if (!formData.businessCategory) {
      newErrors.businessCategory = "Mention businessCategory.";
    }
    if (!formData.default_delivery) {
      newErrors.default_delivery = "Mention Delivery Days.";
    }


    if (!formData.addressLine1) {
      newErrors.addressLine1 = "Mention Address Name.";
    } else if (formData.addressLine1.length < 2) {
      newErrors.addressLine1 = "Address name must consist of at least 2 characters.";
    } else if (formData.addressLine1.length > 255) {
      newErrors.addressLine1 = "Address name must not exceed 255 characters.";
    }

    if (!formData.city) {
      newErrors.city = "Mention city Name.";
    } else if (formData.city.length < 2) {
      newErrors.city = "city name must consist of at least 2 characters.";
    } else if (formData.city.length > 255) {
      newErrors.city = "city name must not exceed 255 characters.";
    }

    if (!formData.county) {
      newErrors.county = "Mention county Name.";
    } else if (formData.county.length < 2) {
      newErrors.county = "county name must consist of at least 2 characters.";
    } else if (formData.county.length > 255) {
      newErrors.county = "county name must not exceed 255 characters.";
    }

    if (!formData.postalCode) {
      newErrors.postalCode = "Mention postal code .";
    } else if (formData.postalCode.length < 2) {
      newErrors.postalCode = "postal code name must consist of at least 2 digit.";
    } else if (formData.county.length > 255) {
      newErrors.postalCode = "postal code name must not exceed 255 digit.";
    }

    // Facility-specific validations
    if (creditFacility === '1') {
      if (
        !formData.day_wise &&
        !formData.invoice_wise &&
        !formData.amount_wise
      ) {
        localFacilityError = 'At least one facility is required when Credit Facility is selected.';
      }
      if (formData.day_wise && !formData.total_day) {
        newErrors.total_day = "Total Days is required.";
      }
      if (formData.invoice_wise && !formData.total_invoice) {
        newErrors.total_invoice = "Total Invoice is required.";
      }
      if (formData.amount_wise && !formData.total_amount) {
        newErrors.total_amount = "Total Amount is required.";
      }
    }

    setFacilityError(localFacilityError);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0 && !localFacilityError;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    let fieldErrors = {};

    // Validate the input field immediately as the user types
    switch (name) {
      case 'companyName':
        if (!value) {
          fieldErrors.companyName = "Mention business Name.";
        } else if (value.length < 2) {
          fieldErrors.companyName = "business name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.companyName = "business name must not exceed 255 characters.";
        }
        if (!fieldErrors.companyName) {
          fieldErrors.companyName = '';
        }
        break;

      case 'firstName':
        if (!value) {
          fieldErrors.firstName = "Mention Name.";
        } else if (value.length < 2) {
          fieldErrors.firstName = "Name must consist of at least 2 characters.";
        } else if (value.length > 255) {

          fieldErrors.firstName = "Name must not exceed 255 characters.";
        }
        if (!fieldErrors.firstName) {
          fieldErrors.firstName = '';
        }
        break;

      case 'phone':
        if (!value) {
          fieldErrors.phone = "Phone is Required.";
        } else if (!/^\d{10,12}$/.test(value)) {
          fieldErrors.phone = "Phone number must be between 10 and 12 digits.";
        }
        if (!fieldErrors.phone) {

          fieldErrors.phone = '';
        }
        break;

      case 'emailId':
        if (company_tax_type !== 'GST') {
          if (!value) {
            fieldErrors.emailId = "Email is Required.";
          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            fieldErrors.emailId = "Please enter a valid email address.";
          }
        } else if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          fieldErrors.emailId = "Please enter a valid email address.";
        }
        if (!fieldErrors.emailId) {
          fieldErrors.emailId = '';
        }
        break;




      case 'accound_no':

        if (!value) {
          fieldErrors.accound_no = "Account Number is Required.";
        } else if (value.length < 2) {
          fieldErrors.accound_no = "No consist of at least 2 digits.";
        } else if (value.length > 15) {
          fieldErrors.accound_no = "No must not exceed 15 digits.";
        }
        if (!fieldErrors.accound_no) {
          fieldErrors.accound_no = '';
        }
        break;






      case 'route':
        if (!value) {
          fieldErrors.route = "Mention route.";
        }
        if (!fieldErrors.route) {
          fieldErrors.route = '';
        }
        break;

      case 'typeOfBusiness':
        if (!value) {
          fieldErrors.typeOfBusiness = "Mention typeOfBusiness.";
        }
        if (!fieldErrors.typeOfBusiness) {
          fieldErrors.typeOfBusiness = '';
        }
        break;

      case 'businessCategory':
        if (!value) {
          fieldErrors.businessCategory = "Mention businessCategory.";
        }
        if (!fieldErrors.businessCategory) {
          fieldErrors.businessCategory = '';
        }
        break;



      case 'default_delivery':
        if (!value) {
          fieldErrors.default_delivery = "Mention Delivery Days.";
        }
        if (!fieldErrors.default_delivery) {
          fieldErrors.default_delivery = '';
        }
        break;

      case 'addressLine1':
        if (!value) {
          fieldErrors.addressLine1 = "Mention Address.";
        } else if (value.length < 2) {
          fieldErrors.addressLine1 = "Address must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.addressLine1 = "Address must not exceed 255 characters.";
        }
        if (!fieldErrors.addressLine1) {
          fieldErrors.addressLine1 = '';
        }
        break;

      case 'city':
        if (!value) {
          fieldErrors.city = "Mention city.";
        } else if (value.length < 2) {
          fieldErrors.city = "city must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.city = "city must not exceed 255 characters.";
        }
        if (!fieldErrors.city) {
          fieldErrors.city = '';
        }
        break;

      case 'county':
        if (!value) {
          fieldErrors.county = "Mention county.";
        } else if (value.length < 2) {
          fieldErrors.county = "county must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.county = "county must not exceed 255 characters.";
        }
        if (!fieldErrors.county) {
          fieldErrors.county = '';
        }
        break;

      case 'postalCode':
        if (!value) {
          fieldErrors.postalCode = "Mention postal code.";
        } else if (value.length < 2) {
          fieldErrors.postalCode = "postal code must consist of at least 2 digit.";
        } else if (value.length > 255) {
          fieldErrors.postalCode = "postal code must not exceed 255 digit.";
        }
        if (!fieldErrors.postalCode) {
          fieldErrors.postalCode = '';
        }
        break;





      default:
        break;
    }

    // Update errors state for the specific field
    setErrors((prevErrors) => ({
      ...prevErrors,
      ...fieldErrors
    }));
  };

  const submitAddCustomerForm = async () => {
    if (!validateForm()) return;

    // Facility validation
    if (
      creditFacility === '1' &&
      !formData.day_wise &&
      !formData.invoice_wise &&
      !formData.amount_wise
    ) {
      setFacilityError('At least one facility is required when Credit Facility is selected.');
      return;
    }
    setFacilityError('');

    setIsSubmitting(true);
    const formPayload = new FormData();
    const requestPayload = {
      user_id: userId,
      cid: formData.id,
      companyName: formData.companyName,
      firstName: formData.firstName,
      emailId: formData.emailId,
      phone: formData.phone,
      accound_no: formData.accound_no,
      route: formData.route,
      addressLine1: formData.addressLine1,
      addressLine2: formData.addressLine2 || '',
      city: formData.city,
      postalCode: formData.postalCode,
      county: formData.county,
      vatNo: formData.vatNo || '',
      default_delivery: formData.default_delivery,
      typeOfBusiness: formData.typeOfBusiness,
      businessCategory: formData.businessCategory,
      product_price: formData.product_price || '',
      credit_facility: creditFacility,
      day_wise: formData.day_wise ? '1' : '0',
      total_day: formData.total_day || '',
      invoice_wise: formData.invoice_wise ? '1' : '0',
      total_invoice: formData.total_invoice || '',
      amount_wise: formData.amount_wise ? '1' : '0',
      total_amount: formData.total_amount || '',
      driving_license: formData.driving_license || '',
      passport: formData.passport || '',
      shiptoName: company_tax_type === 'GST' ? formData.shiptoName || '' : '',
      shipLine1: company_tax_type === 'GST' ? formData.shipLine1 || '' : '',
      shipLine2: company_tax_type === 'GST' ? formData.shipLine2 || '' : '',
      shipCity: company_tax_type === 'GST' ? formData.shipCity || '' : '',
      shipPostcode: company_tax_type === 'GST' ? formData.shipPostcode || '' : '',
      shipState: company_tax_type === 'GST' ? formData.shipState || '' : '',
    };
    const settings = await getCompanySettings();
    const useEncrypt = resolveCustomerApiEncrypt(settings);
    if (useEncrypt) {
      const encryptedPayload = encryptPayload(requestPayload);
      if (!encryptedPayload) {
        toast.error('Encryption key missing.');
        setIsSubmitting(false);
        return;
      }
      formPayload.append('encrypted_payload', encryptedPayload);
    } else {
      Object.entries(requestPayload).forEach(([key, value]) => {
        formPayload.append(key, value == null ? '' : String(value));
      });
    }
    try {
      const response = await axios.post(`${config.API_URL}/update_customer_details`, formPayload, {
        headers: {
          authorization: `Bearer ${token}`,
        }
      });

      const raw = response.data;
      const result = useEncrypt
        ? (decryptPayload(raw?.encrypted_payload) ||
            decryptPayload(raw?.encrypted_data) ||
            decryptPayload(raw?.payload) ||
            raw)
        : raw;
      const msg = result.message;

      if (result.success == true) {
        toast.success('Customer updated successfully.');
        if (embedded) {
          if (typeof onClose === 'function') {
            setTimeout(() => onClose(), 800);
          }
        } else {
          setTimeout(() => navigateToCustomerList('/customers/'), 1500);
        }
      } else {
        toast.error(msg || 'Update failed.');
      }
    } catch {
    } finally {
      setIsSubmitting(false); // Re-enable the button
    }
  };

  const handleProductPriceChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      product_price: event.target.value,
    }));
  };

  const drivingLicenseImages = buildImageCandidates(formData.driving_license);
  const passportImages = buildImageCandidates(formData.passport);
  const drivingLicenseSrc = drivingLicenseImages[drivingImageIndex] || "";
  const passportSrc = passportImages[passportImageIndex] || "";

  return (
    <>
      <Box className="page-container" sx={embedded ? { p: 0, m: 0, maxWidth: '100%' } : undefined}>
        <Paper className="paper-style" sx={embedded ? { boxShadow: 'none', border: 'none', m: 0 } : undefined}>
          <Box sx={{ px: embedded ? 1 : 2, py: embedded ? 1 : 1.2 }} component="form" id="addcustomerform">
            <input type="hidden" name="user_id" id="user_id" value={userId} />
            <input type="hidden" name="cid" id="cid" value={formData.id} />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: embedded ? 1 : 0 }}>
              <Typography className="page-title" sx={{ mb: 0 }}>Edit Customer</Typography>
              {headerActions}
            </Box>
            <Typography variant="body2" sx={{ mb: 3, color: 'text.primary', fontSize: '0.75rem' }}>
              Please fill in the information below. The field labels marked with <span style={{ color: 'red' }}>*</span> are required input fields.
            </Typography>
            <Grid2 container spacing={3}>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Business Name"
                  name="companyName"
                  id="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  error={!!errors.companyName}
                  helperText={errors.companyName}
                  required
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Customer Name"
                  name="firstName"
                  id="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  required
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Email Address"
                  name="emailId"
                  id="emailId"
                  type="email"
                  value={formData.emailId}
                  onChange={handleChange}
                  error={!!errors.emailId}
                  helperText={errors.emailId}
                  required={company_tax_type !== 'GST'}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Phone"
                  name="phone"
                  id="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  required
                  inputProps={{
                    style: {
                      appearance: "none",
                      MozAppearance: "textfield",
                    }
                  }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <Autocomplete
                  className="form-input-border"
                  size="small"
                  options={businessRute}
                  value={
                    businessRute.find((r) => String(r.id) === String(formData.route ?? '')) || null
                  }
                  onChange={(_event, option) => {
                    const nextValue = option ? String(option.id) : '';
                    setFormData((prev) => ({ ...prev, route: nextValue }));
                    setErrors((prev) => ({
                      ...prev,
                      route: nextValue ? '' : prev.route,
                    }));
                  }}
                  getOptionLabel={(option) => String(option?.route_number ?? '').trim()}
                  isOptionEqualToValue={(option, value) => String(option?.id) === String(value?.id)}
                  filterOptions={(options, state) => {
                    const query = String(state.inputValue || '').trim().toLowerCase();
                    if (!query) return options;
                    return options.filter((option) =>
                      String(option?.route_number ?? '').trim().toLowerCase().includes(query)
                    );
                  }}
                  slotProps={{
                    popper: {
                      sx: { zIndex: 2000 },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="form-input-border"
                      label="Route"
                      required
                      error={!!errors.route}
                      helperText={errors.route || ''}
                    />
                  )}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <FormControl className="form-input-border" fullWidth size="small" required error={!!errors.typeOfBusiness}>
                  <InputLabel>Type of Business</InputLabel>
                  <Select
                    name="typeOfBusiness"
                    value={formData.typeOfBusiness}
                    label="Type of Business"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {businessType.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.type_business}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.typeOfBusiness && <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>{errors.typeOfBusiness}</Typography>}
                </FormControl>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <FormControl className="form-input-border" fullWidth size="small" required error={!!errors.businessCategory}>
                  <InputLabel>Business Category</InputLabel>
                  <Select
                    className="form-input-border"
                    name="businessCategory"
                    value={formData.businessCategory}
                    label="Business Category"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {businessCategory.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.category_name}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.businessCategory && <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>{errors.businessCategory}</Typography>}
                </FormControl>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <FormControl className="form-input-border" fullWidth size="small" required={company_tax_type !== 'GST'} error={!!errors.default_delivery}>
                  <InputLabel>Delivery Days</InputLabel>
                  <Select
                    name="default_delivery"
                    value={formData.default_delivery}
                    label="Delivery Days"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="2">1 Days Delivery</MenuItem>
                    <MenuItem value="1">3 Days Delivery</MenuItem>
                    <MenuItem value="3">7 Days Delivery</MenuItem>
                  </Select>
                  {errors.default_delivery && <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>{errors.default_delivery}</Typography>}
                </FormControl>
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Address"
                  name="addressLine1"
                  id="addressLine1"
                  value={formData.addressLine1}
                  onChange={handleChange}
                  error={!!errors.addressLine1}
                  helperText={errors.addressLine1}
                  required
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Address 2"
                  name="addressLine2"
                  id="addressLine2"
                  value={formData.addressLine2 || ''}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="City"
                  name="city"
                  id="city"
                  value={formData.city}
                  onChange={handleChange}
                  error={!!errors.city}
                  helperText={errors.city}
                  required
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label={company_tax_type === 'GST' ? 'State' : 'County'}
                  name="county"
                  id="county"
                  value={formData.county}
                  onChange={handleChange}
                  error={!!errors.county}
                  helperText={errors.county}
                  required
                />
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Postal Code"
                  name="postalCode"
                  id="postalCode"
                  value={formData.postalCode}
                  onChange={handleChange}
                  error={!!errors.postalCode}
                  helperText={errors.postalCode}
                  required
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Account Number (User Name)"
                  name="accound_no"
                  id="accound_no"
                  value={formData.accound_no}
                  onChange={handleChange}
                  error={!!errors.accound_no}
                  helperText={errors.accound_no}
                  required={company_tax_type !== 'GST'}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label={`${company_tax_type} Number`}
                  name="vatNo"
                  id="vatNo"
                  value={formData.vatNo || ''}
                  onChange={handleChange}
                />

              </Grid2>
            </Grid2>
            <Grid2 container spacing={3} sx={{ my: 3 }}>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <input type="hidden" name="driving_license" value={formData.driving_license || ''} />
                <Typography sx={{ mb: 0.5, fontSize: '0.875rem', color: '#212b36' }}>Driving License</Typography>
                {drivingLicenseSrc && !drivingImageUnavailable ? (
                  <Box
                    component="img"
                    src={drivingLicenseSrc}
                    alt="Driving License"
                    onError={() => {
                      setDrivingImageIndex((prev) => {
                        const next = prev + 1;
                        if (next < drivingLicenseImages.length) {
                          return next;
                        }
                        setDrivingImageUnavailable(true);
                        return prev;
                      });
                    }}
                    sx={{
                      width: '100%',
                      maxWidth: 220,
                      height: 140,
                      objectFit: 'cover',
                      borderRadius: 1,
                      border: '1px solid rgba(145, 158, 171, 0.24)'
                    }}
                  />
                ) : (
                  <Typography sx={{ fontSize: '0.75rem', color: '#000' }}>No image uploaded</Typography>
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                <input type="hidden" name="passport" value={formData.passport || ''} />
                <Typography sx={{ mb: 0.5, fontSize: '0.875rem', color: '#212b36' }}>Passport</Typography>
                {passportSrc && !passportImageUnavailable ? (
                  <Box
                    component="img"
                    src={passportSrc}
                    alt="Passport"
                    onError={() => {
                      setPassportImageIndex((prev) => {
                        const next = prev + 1;
                        if (next < passportImages.length) {
                          return next;
                        }
                        setPassportImageUnavailable(true);
                        return prev;
                      });
                    }}
                    sx={{
                      width: '100%',
                      maxWidth: 220,
                      height: 140,
                      objectFit: 'cover',
                      borderRadius: 1,
                      border: '1px solid rgba(145, 158, 171, 0.24)'
                    }}
                  />
                ) : (
                  <Typography sx={{ fontSize: '0.75rem', color: '#000' }}>No image uploaded</Typography>
                )}
              </Grid2>
            </Grid2>

            {company_tax_type === 'GST' && (
              <>
                <Grid2 size={{ xs: 12 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Ship To Details
                    </Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={sameAsBillTo}
                          onChange={handleSameAsBillToChange}
                        />
                      }
                      label="Same as Bill To"
                    />
                  </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                  <TextField
                    className="form-input-border"
                    fullWidth
                    size="small"
                    label="Name"
                    name="shiptoName"
                    id="shiptoName"
                    value={formData.shiptoName}
                    onChange={handleChange}
                    disabled={sameAsBillTo}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                  <TextField
                    className="form-input-border"
                    fullWidth
                    size="small"
                    label="Address Line 1"
                    name="shipLine1"
                    id="shipLine1"
                    value={formData.shipLine1}
                    onChange={handleChange}
                    disabled={sameAsBillTo}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                  <TextField
                    className="form-input-border"
                    fullWidth
                    size="small"
                    label="Address Line 2"
                    name="shipLine2"
                    id="shipLine2"
                    value={formData.shipLine2}
                    onChange={handleChange}
                    disabled={sameAsBillTo}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                  <TextField
                    className="form-input-border"
                    fullWidth
                    size="small"
                    label="City"
                    name="shipCity"
                    id="shipCity"
                    value={formData.shipCity}
                    onChange={handleChange}
                    disabled={sameAsBillTo}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                  <TextField
                    className="form-input-border"
                    fullWidth
                    size="small"
                    label="Postcode"
                    name="shipPostcode"
                    id="shipPostcode"
                    value={formData.shipPostcode}
                    onChange={handleChange}
                    disabled={sameAsBillTo}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                  <TextField
                    className="form-input-border"
                    fullWidth
                    size="small"
                    label="State"
                    name="shipState"
                    id="shipState"
                    value={formData.shipState}
                    onChange={handleChange}
                    disabled={sameAsBillTo}
                  />
                </Grid2>
              </>
            )}

            <Grid2 size={{ xs: 12 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "flex-start",
                  gap: 4,
                }}
              >
                <FormControl component="fieldset" sx={{ minWidth: 0 }}>
                  <FormLabel component="legend" variant="caption" sx={{ fontWeight: 500, color: "#000" }}>
                    Product Price
                  </FormLabel>
                  <RadioGroup
                    row
                    name="product_price"
                    value={formData.product_price}
                    onChange={handleProductPriceChange}
                    sx={{
                      marginTop: -1.5,
                      flexDirection: "row",
                      flexWrap: "wrap",
                    }}
                  >
                    <FormControlLabel value="1" control={<Radio className="checkBox" />} label="Price 1" />
                    <FormControlLabel value="2" control={<Radio className="checkBox" />} label="Price 2" />
                    <FormControlLabel value="3" control={<Radio className="checkBox" />} label="Price 3" />
                    <FormControlLabel value="4" control={<Radio className="checkBox" />} label="Price 4" />
                    <FormControlLabel value="5" control={<Radio className="checkBox" />} label="Price 5" />
                    <FormControlLabel value="6" control={<Radio className="checkBox" />} label="Price 6" />
                  </RadioGroup>
                </FormControl>
                <FormControl component="fieldset" sx={{ minWidth: 0 }}>
                  <FormLabel component="legend" variant="caption" sx={{ fontWeight: 500, color: "#000" }}>
                    Credit Facility
                  </FormLabel>
                  <RadioGroup
                    row
                    name="credit_facility"
                    value={creditFacility}
                    onChange={handleRadioChange}
                    sx={{
                      marginTop: -1.5,
                      flexDirection: "row",
                      flexWrap: "wrap",
                    }}
                  >
                    <FormControlLabel value="1" control={<Radio className="checkBox" />} label="Credit Facility" />
                    <FormControlLabel value="0" control={<Radio className="checkBox" />} label="Credit Facility Cash" />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Grid2>

            {creditFacility === '1' && (
              <Grid2 size={{ xs: 12, sm: 9 }}>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <Box className="border-box" sx={{ p: 2}}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            className="checkBox"
                            name="day_wise"
                            checked={formData.day_wise === true}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Day Wise"
                      />
                      {formData.day_wise === true && (
                        <Box sx={{ mt: 2 }}>
                          <TextField
                            className="form-input-border"
                            fullWidth
                            size="small"
                            label="Total Days"
                            name="total_day"
                            value={formData.total_day}
                            onChange={handleChange}
                            error={!!errors.total_day}
                            helperText={errors.total_day}
                          />
                        </Box>
                      )}
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <Box className="border-box" sx={{ p: 2}}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            className="checkBox"
                            name="invoice_wise"
                            checked={formData.invoice_wise === true}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Invoice Wise"
                      />
                      {formData.invoice_wise === true && (
                        <Box sx={{ mt: 2 }}>
                          <TextField
                            className="form-input-border"
                            fullWidth
                            size="small"
                            label="Total Invoice"
                            name="total_invoice"
                            value={formData.total_invoice}
                            onChange={handleChange}
                            error={!!errors.total_invoice}
                            helperText={errors.total_invoice}
                          />
                        </Box>
                      )}
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <Box className="border-box" sx={{ p: 2}}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            className="checkBox"
                            name="amount_wise"
                            checked={formData.amount_wise === true}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Amount Wise"
                      />
                      {formData.amount_wise === true && (
                        <Box sx={{ mt: 2 }}>
                          <TextField
                            className="form-input-border"
                            fullWidth
                            size="small"
                            label="Total Amount"
                            name="total_amount"
                            value={formData.total_amount}
                            onChange={handleChange}
                            error={!!errors.total_amount}
                            helperText={errors.total_amount}
                          />
                        </Box>
                      )}
                    </Box>
                  </Grid2>
                </Grid2>
                {facilityError && (
                  <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                    {facilityError}
                  </Typography>
                )}
              </Grid2>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, pt: 2, borderTop: '1px solid rgba(145, 158, 171, 0.16)' }}>
              <Button
                variant="contained"
                onClick={submitAddCustomerForm}
                disabled={isSubmitting}
                className="button-variant-contained"
              >
                {isSubmitting ? 'Updating Customer...' : 'Update Customer'}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
};



export default Edit_Customer;
